<template>
  <div class="transferResultSuccessDetail">
    <!-- 交易成功 -->
    <template v-if="+status === TRANSACTION_STATUS.success">
      <div class="status-icon success_icon">
        <md-icon name="success" size="lg" />
        <p>{{ $t('completed') }}</p>
      </div>
    </template>

    <!-- 交易失败 -->
    <template v-if="+status === TRANSACTION_STATUS.fail">
      <div class="status-icon fail">
        <md-icon name="warn" size="lg" />
        <p>{{ $t('transaction_failed') }}</p>
        <p class="reason">({{ $t('money_wallet') }})</p>
        <p class="reason">{{ message }}</p>
      </div>
    </template>

    <!-- 等待支付 -->
    <template v-if="[TRANSACTION_STATUS.wait].includes(+status)">
      <div class="status-icon wait">
        <md-icon name="time" size="lg" />
        <p>{{ $t('wait_for_payment') }}</p>
        <p class="reason">{{ message }}</p>
      </div>
    </template>

    <!-- 银行受理 银行处理 -->
    <template v-if="[TRANSACTION_STATUS.pend, TRANSACTION_STATUS.pending].includes(+status)">
      <div class="status-icon wait">
        <md-icon name="time" size="lg" />
        <p>{{ $t('processing') }}</p>
        <p class="reason">{{ message }}</p>
      </div>
    </template>

    <!-- 交易超时 -->
    <template v-if="+status === TRANSACTION_STATUS.timeout">
      <div class="status-icon timeout">
        <md-icon name="warn" size="lg" />
        <p>{{ $t('payment_cancelled') }}</p>
        <p v-if="message" class="reason">{{ message }}</p>
      </div>
    </template>

    <div class="transfer_info">
      <slot />
    </div>

    <div class="footer_btn">
      <template v-if="showButton">
        <!-- 只有失败的时候才有 -->
        <md-button
          v-if="+status === TRANSACTION_STATUS.fail"
          type="primary"
          @click="$router.push({name: name})"
        >
          {{ $t('try_again') }}
        </md-button>

        <md-button
          style="border: 1px solid #333;"
          type="default"
          :class="['tryBtn', name ? 'footer_btn_second' : '']"
          @click="$router.push('/home')"
        >
          {{ $t('back_to_homepage') }}
        </md-button>
      </template>

      <!-- 去支付 -->
      <!--      <md-button-->
      <!--        v-if="+tradeType === TRADE_TYPE.CONSUME && +status === TRANSACTION_STATUS.wait"-->
      <!--        type="primary"-->
      <!--        @click="$router.push({name: name})"-->
      <!--      >-->
      <!--        去支付-->
      <!--      </md-button>-->
    </div>
  </div>
</template>

<script>
import { Icon, Field, DetailItem, Button } from 'mand-mobile'
import { TRANSACTION_STATUS, TRADE_TYPE } from '@/constants'

export default {
  name: 'ResultBankNoSteps',

  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [DetailItem.name]: DetailItem,
    [Button.name]: Button
  },

  props: {
    status: {
      type: [String, Number],
      required: true
    },

    message: {
      type: String,
      required: true
    },

    name: {
      type: String,
      default: ''
    },

    tradeType: {
      type: [String, Number],
      required: true
    },

    isHistory: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      TRANSACTION_STATUS,
      TRADE_TYPE
    }
  },
  computed: {
    showButton () {
      return !this.isHistory
    }
  }
}
</script>

<style lang="scss" scoped>
.transferResultSuccessDetail {
  width: 100%;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .status-icon {
    margin-top: 108px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      font-size: 32px;
      font-weight: 500;
      margin-top: 26px;
    }

    .reason {
      font-size: 24px;
      color: #7f7f7f;
    }

    .md-icon {
      font-size: 124px;
      color: #65c32c;
    }
  }

  .fail {
    .md-icon {
      color: #fa5151;
    }
  }

  .timeout {
    .md-icon {
      color: #b2b2b2;
    }

    p {
      text-align: center;
    }
  }

  .wait {
    .md-icon {
      color: #ffc300;
    }
  }

  .error_icon {
    margin-top: 108px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .md-icon {
      font-size: 124px;
      color: #fa5151;
    }

    p {
      font-size: 32px;
      color: #fa5151;
      font-weight: 500;
      margin-top: 26px;
    }
  }

  .transfer_info {
    display: flex;
    width: 100%;
    margin-top: 70px;
    background: #fff;
    border-radius: 32px;
    box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
  }

  .footer_btn {
    width: 100%;
    margin-top: 202px;
    margin-bottom: 74px;

    .footer_btn_second {
      margin-top: 64px;
    }

    .md-button.default::after {
      border: none;
      border-radius: 24px;
    }

    .tryBtn {
      border-radius: 24px;
    }
  }
}

.md-field {
  display: block;
  width: 100%;
  border-radius: 32px;
}

.md-detail-item {
  line-height: 78px;
}

.md-detail-title {
  color: #7f7f7f;
  font-size: 28px;
}

.md-detail-content {
  color: #333;
  font-size: 28px;
}

/* stylelint-disable selector-pseudo-element-no-unknown */
::v-deep .md-detail-item:first-child {
  .md-detail-content {
    font-size: 36px;
    color: #242424;
  }
}

.md-icon.icon-svg.lg {
  width: 96px !important;
  height: 96px !important;
}

/* stylelint-enable */
</style>
